__webpack_require__.p = "https://assets-01.periodica.press/669b645-24661079228/";